//node-modules
import { useEffect, useRef, useState } from "react";
import { createSearchParams, Navigate, useLocation } from "react-router-dom";
import { config } from "../config/config";
import { validate as isUuid } from "uuid";

type urlProps = {
  path: string;
  children: any;
};

const AuthenticatedGuard = ({ path, children }: urlProps) => {
  const location = useLocation();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isAuthenticated, setIsAuthenticate] = useState<boolean>(false);

  function getCookie(cname: string) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  }

  useEffect(() => {
    const authFunc = async () => {
      setIsLoading(true);

      const login_auth = getCookie("login_auth");

      if (!login_auth) {
        const url = new URL(window.location.href);
        const urlPathname = url.pathname.substring(1); // e.g. "ar/c28154cc-33a4-4139-b231-bd6e44dff5c5"

        // Try to extract UUID from /ar/:projectId or /ios/:lang/:projectId etc.
        let projectId = "";
        const arMatch = urlPathname.match(/^ar\/(.+)$/);
        const iosMatch = urlPathname.match(/^ios(-ar)?\/[^\/]+\/(.+)$/);
        console.log("ios match", iosMatch);
        console.log("arMatch", arMatch);

        if (arMatch && isUuid(arMatch[1])) {
          projectId = arMatch[1];
        } else if (iosMatch && isUuid(iosMatch[1])) {
          projectId = iosMatch[1];
        } else if (isUuid(urlPathname)) {
          projectId = urlPathname;
        }

        if (projectId) {
          window.location.replace(
            `${config.serverHost}/login?type=web&projectId=${urlPathname}`
          );
        } else {
          // 上記以外
          const search = location.search;
          const params = new URLSearchParams(search);

          window.location.replace(
            `${config.serverHost}/login?type=web&${params.toString()}`
          );
        }
      } else {
        setIsAuthenticate(true);
        document.cookie =
          "login_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      setIsLoading(false);
    };

    authFunc();

    return () => {
      setIsLoading(true);
      setIsAuthenticate(false);
      document.cookie =
        "login_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    };
  }, [location.pathname]);

  return isLoading ? <></> : isAuthenticated ? <>{children}</> : <></>;
};

export default AuthenticatedGuard;
